module.exports = __webpack_public_path__ + "static/media/wd_page_area04_img_en.fa59e402.png";